import {Connector} from '../Connector';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Inject, Injectable, Injector} from '@angular/core';
import {Config} from '../../../Config';
import {Factory as SuccessResponseFactory} from '../Response/Success/Factory';
import {Factory as ErrorResponseFactory} from '../Response/Error/Factory';
import {Factory as UnauthorizedErrorResponseFactory} from '../Response/Error/Unauthorized/Factory';
import {Factory as InternalErrorResponseFactory} from '../Response/Error/Internal/Factory';

@Injectable()
export class Factory {

    private config: Config = null;

    private httpClient: HttpClient = null;

    private successResponseFactory: SuccessResponseFactory = null;

    private errorResponseFactory: ErrorResponseFactory = null;

    private headers: HttpHeaders = null;

    private unauthorizedErrorResponseFactory: UnauthorizedErrorResponseFactory = null;

    private internalErrorResponseFactory: InternalErrorResponseFactory = null;

    private injector: Injector = null;

    // ########################################

    constructor(
        @Inject('CONFIG') config: Config,
        httpClient: HttpClient,
        successResponseFactory: SuccessResponseFactory,
        errorResponseFactory: ErrorResponseFactory,
        unauthorizedErrorResponseFactory: UnauthorizedErrorResponseFactory,
        internalErrorResponseFactory: InternalErrorResponseFactory,
        injector: Injector
    ) {
        this.config = config;
        this.httpClient = httpClient;
        this.successResponseFactory = successResponseFactory;
        this.errorResponseFactory = errorResponseFactory;
        this.unauthorizedErrorResponseFactory = unauthorizedErrorResponseFactory;
        this.internalErrorResponseFactory = internalErrorResponseFactory;
        this.injector = injector;

        this.headers = new HttpHeaders({'content-type': 'application/json'});
    }

    // ########################################

    public create(): Connector {
        const baseUrl = (<string>this.config.get('/system/main/base_url/'));

        return new Connector(
            baseUrl,
            this.headers,
            this.httpClient,
            this.successResponseFactory,
            this.errorResponseFactory,
            this.unauthorizedErrorResponseFactory,
            this.internalErrorResponseFactory,
            this.injector
        );
    }

    // ########################################
}
